(() => {
  if (window.pressroomMetaPixel) return;
  const element = document.getElementById('pressroom-meta-config');
  if (!element) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch { return; }
  if (!/^\d+$/.test(config.pixelId)) return;
  window.pressroomMetaPixel = true;
  let initialized = false;
  let viewed = false;

  function allowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.marketingAllowed?.() === true && privacy?.saleOfDataAllowed?.() !== false;
  }

  function initialize() {
    if (initialized) return;
    if (!window.fbq) {
      const fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      window._fbq = window._fbq || fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', config.pixelId);
    window.fbq('set', 'autoConfig', false, config.pixelId);
    initialized = true;
  }

  function track(name, parameters = {}) {
    if (!allowed()) return;
    initialize();
    window.fbq('consent', 'grant');
    window.fbq('trackSingle', config.pixelId, name, parameters);
  }

  function syncConsent() {
    if (!allowed()) {
      if (initialized) window.fbq('consent', 'revoke');
      return;
    }
    if (viewed) {
      if (initialized) window.fbq('consent', 'grant');
      return;
    }
    viewed = true;
    track('PageView');
    if (config.product) {
      track('ViewContent', {
        content_ids: [config.product.id],
        content_type: 'product',
        content_name: config.product.title,
        currency: config.currency,
        value: config.product.value,
      });
    }
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('pressroom:cart-added', (event) => {
    const item = event.detail?.item;
    const quantity = Number(event.detail?.quantity);
    const price = Number(item?.final_price ?? item?.price);
    if (!item?.product_id || !Number.isFinite(quantity) || quantity < 1 || !Number.isFinite(price)) return;
    track('AddToCart', {
      content_ids: [String(item.product_id)],
      content_type: 'product',
      content_name: item.product_title ?? item.title,
      currency: config.currency,
      value: (price / 100) * quantity,
      num_items: quantity,
    });
  });
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) syncConsent();
    });
  }
})();
